import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import StatusBadge from "@/components/StatusBadge";

export default function ProductCard({ project, large = false }) {
  const accent = project.accent || "#d4af37";
  const monogram = (project.name || "?").charAt(0);

  return (
    <div
      data-testid={`product-card-${project.slug}`}
      className="card-hover group relative flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-ink-800 p-7"
      style={{ "--accent": accent }}
    >
      <div
        className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full opacity-20 blur-3xl transition-opacity duration-500 group-hover:opacity-40"
        style={{ background: accent }}
      />
      <div className="relative z-10 flex items-start justify-between">
        <div className="flex items-center gap-3">
          {project.logo ? (
            <img src={project.logo} alt={project.name} className="h-11 w-11 rounded-xl object-cover" />
          ) : (
            <div
              className="flex h-11 w-11 items-center justify-center rounded-xl font-display text-xl font-bold"
              style={{ background: `${accent}1a`, color: accent, border: `1px solid ${accent}40` }}
            >
              {monogram}
            </div>
          )}
          <div>
            <h3 className={`font-display font-semibold text-white ${large ? "text-2xl" : "text-xl"}`}>{project.name}</h3>
            <p className="font-mono2 text-[10px] uppercase tracking-widest text-white/40">{project.industry}</p>
          </div>
        </div>
        <StatusBadge status={project.status} />
      </div>

      <p className="relative z-10 mt-5 font-display text-lg font-light leading-snug" style={{ color: accent }}>
        {project.tagline}
      </p>
      <p className="relative z-10 mt-3 flex-1 font-body text-sm leading-relaxed text-white/55">{project.description}</p>

      <div className="relative z-10 mt-7 flex flex-wrap items-center gap-3">
        <Link
          to={`/technology/${project.slug}`}
          data-testid={`learn-more-${project.slug}`}
          className="btn-ghost inline-flex items-center gap-1.5 rounded-full px-4 py-2 font-mono2 text-[11px] uppercase tracking-widest"
        >
          Learn More <ArrowRight size={13} />
        </Link>
        {project.website_url ? (
          <a
            href={project.website_url}
            target="_blank"
            rel="noreferrer"
            data-testid={`launch-${project.slug}`}
            className="inline-flex items-center gap-1.5 rounded-full px-4 py-2 font-mono2 text-[11px] uppercase tracking-widest text-black"
            style={{ background: accent }}
          >
            {project.cta_label || "Launch Platform"} <ArrowUpRight size={13} />
          </a>
        ) : null}
      </div>

      <div className="relative z-10 mt-6 flex items-center gap-2 border-t border-white/5 pt-4">
        <span className="flex h-4 w-4 items-center justify-center rounded-full bg-gradient-to-br from-gold-dark via-gold to-gold-light text-[8px] font-bold text-black font-display">
          J
        </span>
        <span className="font-mono2 text-[9px] uppercase tracking-[0.2em] text-white/35">Powered by ImJove Tech</span>
      </div>
    </div>
  );
}
